module.exports = __webpack_public_path__ + "static/media/psolar.a5ea0425.jpg";